<evc-frame>
  <div frame-title class="page-header">
    <p class="eyebrow">Fresh from the oven</p>
    <h3 class="page-title">
      <evc-icon aria-hidden="true" icon="user" size="sm"></evc-icon>
      Welcome back, {{ userName() }}!
      <span class="title-icon" aria-hidden="true">🧁</span>
    </h3>
    <p class="page-subtitle">Your pastry corner is ready for baking, snacking, and syncing.</p>
  </div>
  <div frame-content class="page-content">
    <section class="intro-card">
      <p class="intro-text">This page showcases communication with a database and Azure Storage.</p>
      <p class="intro-text">Use this space to bake pastries, manage inventory, and move data around.</p>
    </section>

    <div class="flex-container action-row">
        <evc-button
          type="primary"
          frame="full"
          (click)="addChocolateCroissant()"
          [text]="'Bake Chocolate Croissant'"
        />
        <evc-button
          type="destructive"
          frame="full"
          (click)="eatPastries()"
          [text]="'Eat Pastries'"
        />
    </div>

    <div class="inventory-heading">
      <h3>Inventory</h3>
      <span class="inventory-icon" aria-hidden="true">🍓</span>
    </div>

      @if (pastries().length === 0) {
        <p class="empty-state">No pastries in stock. Time to bake!</p>
      } @else {
        <ol class="flex-container inventory-list">
          @for (pastry of pastries(); track pastry.id) {
            <li class="inventory-card">
              <p class="pastry-name">{{ pastry.name }} <span aria-hidden="true">🥐</span></p>
              <ul class="pastry-details">
                <li>Sweet: {{ pastry.isSweet ? 'YES!' : 'No...' }}</li>
                <li>Savory: {{ pastry.isSavory ? 'YES!' : 'No...' }}</li>
                <li>Tastiness score: {{ pastry.tastynessScore }}</li>
              </ul>
            </li>
          }
        </ol>
      }

      <div class="flex-container action-row action-row--secondary">
        <evc-button
          type="neutral"
          frame="full"
          [text]="'Upload Inventory'"
          (click)="uploadInventory()"
        ></evc-button>
        <evc-button
          type="neutral"
          frame="ghost"
          [text]="'Download Inventory'"
          (click)="downloadInventory()"
        ></evc-button>
      </div>
  </div>
</evc-frame>
